import DtoReferencial from './DtoReferencial'

export default class DtoLandmark extends DtoReferencial {
    constructor(obj) {
        super(obj)
    }
}
